import React, { Component }  from 'react';
import Map                   from './../components/Map/containers/MapContainer';
import LoadingSvg            from './LoadingSvg';
import _                     from 'lodash';

import './../css/PlaceList.css';

class PlaceMapView extends Component {

    componentWillMount = () =>
    {
        if (this.props.directions.show)
        {
            this.resetDirections();
        }
    };

    /**
     * Only update the map if the the filter has been changed or location has been switched on or off.
     *
     * @param nextProps
     * @returns {boolean}
     */
    shouldComponentUpdate = (nextProps) =>
    {
        if (
            this.props.hasGoogle !== nextProps.hasGoogle
            || this.props.geo.stored !== nextProps.geo.stored
            || this.props.directions !== nextProps.directions
        )
        {
            return true;
        }

        return !(this.props.filter.selected.id === nextProps.filter.selected.id);
    };

    componentWillReceiveProps = (nextProps) =>
    {
        if (
            nextProps.directions.show
            &&
            (
                (!this.props.directions.show)
                ||
                nextProps.geo.coords !== this.props.geo.coords
                ||
                (nextProps.directions.place !== this.props.directions.place)
            )
        )
        {
            this.saveDirections(nextProps);
        }
    };

    showDirections = (place) =>
    {
        this.props.showDirections(place);
    };

    resetDirections = () =>
    {
        this.props.resetDirections();
    };

    /**
     * If direction show state is true and user location coords exist, fetch a directions result
     * from the Google API, else reset any directions result
     *
     * Close any open info windows.
     *
     * @param props
     */
    saveDirections = (props) =>
    {
        if (props.directions.show === true && null !== props.geo.coords)
        {
            let origin      = { lat: props.geo.coords.latitude, long: props.geo.coords.longitude };
            let destination = { lat: props.directions.place.coords.lat, long: props.directions.place.coords.long };
            this.props.fetchDirections(origin, destination);
        }
        else
        {
            this.props.resetDirections();
        }
    };


    /**
     * Only return a directions result if the place destination is in the places array.
     *
     * @returns {*}
     */
    getDirections = () => {
        if (this.props.directions.show)
        {
            let placeFound = _.find(this.props.places, { id: this.props.directions.place.id });
            if (typeof placeFound !== 'undefined')
            {
                return this.props.directions.result;
            }
            else
            {
                return null;
            }
        }
        else
        {
            return this.props.directions.result;
        }
    };

    render = () => {
        if (null === this.props.filter || false === this.props.hasGoogle)
        {
            return (
                <div className="places-list">
                    <LoadingSvg />
                </div>
            );
        }
        else
        {
            let origin;
            let user = null;
            if (this.props.geo.coords)
            {
                let { coords } = this.props.geo;
                origin = { lat: coords.latitude, lng: coords.longitude };
                user   = coords;
            }

            let directions = this.getDirections();

            return (
                <div className="places-map">
                    <div className="map">
                        <Map
                            loadingElement={
                                <div style={ { height: '100%' } }>
                                    <LoadingSvg />
                                </div>
                            }
                            containerElement={ <div style={{ height: '100%' }} /> }
                            mapElement={ <div style={{ height: '100%' }} /> }
                            places={ this.props.places }
                            user={ user }
                            origin={ origin }
                            setMapObject={ this.props.setMapObject }
                            directions={ directions }
                            showTrails={ 'All' === this.props.filter.selected.name }
                            listView={ true }
                        />
                    </div>
                </div>
            );
        }
    }
}

export default PlaceMapView;


// WEBPACK FOOTER //
// ./src/components/PlaceMapView.js